<div class="form-horizontal" ngForm="engagementSettingsForm">
	<div class="form-group row" *ngIf="accountLevelPollsEnabled">
		<label class="control-label col-sm-3" id="ewEnablePolls">{{ 'Event_Polls' | translate }}</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<div aria-labelledby="ewEnablePolls" vbUiRadioBtnGroup>
						<button type="button" class="btn btn-admin btn-white" name="pollsEnabled" [(ngModel)]="webcast.pollsEnabled" (ngModelChange)="onTogglePolls(true)" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
							{{ 'UI_Enabled' | translate }}
						</button>
						<button type="button" class="btn btn-admin btn-white" name="pollsDisabled" [(ngModel)]="webcast.pollsEnabled" (ngModelChange)="onTogglePolls(false)" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
							{{ 'UI_Disabled' | translate }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="accountLevelPollsEnabled && webcast.pollsEnabled" class="form-group row animate-if">
		<label class="control-label col-sm-3"></label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<div [ngClass]="styles.radioGroup">
						<input type="radio" id="userPollsResponseAnonymous" [value]="UserPollsResponseTypes.ANONYMOUS" [(ngModel)]="webcast.userPollsResponse" name="userPollsResponseAnonymous" role="radio"/>
						<label for="userPollsResponseAnonymous">{{ 'Event_UserPollsResponse_Anonymous' | translate }}</label>
					</div>
					<div [ngClass]="styles.radioGroup">
						<input type="radio" id="userPollsResponseLogAll" [value]="UserPollsResponseTypes.LOGALL" [(ngModel)]="webcast.userPollsResponse" name="userPollsResponseLogAll" role="radio"/>
						<label for="userPollsResponseLogAll">{{ 'Event_UserPollsResponse_LogAll' | translate }}</label>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="isAddPollVisible && webcast.polls?.length" class="form-group row animate-if">
		<label class="control-label col-sm-3"></label>
		<div class="col-sm-5">
			<div class="row">
				<div class="col-sm-11" *ngFor="let poll of webcast.polls;let index = index">
					<poll-input [name]="'poll' + index" [(ngModel)]="webcast.polls[index]" (onRemovePoll)="removePoll(index)">
					</poll-input>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="isAddPollVisible" class="form-group row" [ngClass]="styles.addPoll">
		<label class="control-label col-sm-3"></label>
		<div class="col-sm-5">
			<div class="row">
				<div class="col-sm-6 vb-input-field btn-group">
					<add-poll-button (addPoll)="addPoll()">
					</add-poll-button>
				</div>
			</div>
		</div>
	</div>

	<vb-ui-horizontal-form-group *ngIf="features.webcastEngagementSettings.allowChat">
		<label id="ewEnableChat" #uiLabel>{{ 'Event_Chat' | translate }}</label>
		<div uiControl aria-labelledby="ewEnableChat" vbUiRadioBtnGroup>
			<button type="button" class="btn btn-admin btn-white" name="ewChatEnabled" [(ngModel)]="webcast.chatEnabled" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
				{{ 'UI_Enabled' | translate }}
			</button>
			<button type="button" class="btn btn-admin btn-white" name="ewChatDisabled" [(ngModel)]="webcast.chatEnabled" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
				{{ 'UI_Disabled' | translate }}
			</button>
		</div>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group *ngIf="features.webcastEngagementSettings.allowQuestionAndAnswer">
		<label #uiLabel id="ewQuestionAndAnswer">{{ 'Event_QuestionAndAnswerWebcast' | translate }}</label>
		<div uiControl aria-labelledby="ewQuestionAndAnswer" vbUiRadioBtnGroup>
			<button type="button" class="btn btn-admin btn-white" name="ewQuestionAndAnswerEnabled" [(ngModel)]="webcast.questionAndAnswerEnabled" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
				{{ 'UI_Enabled' | translate }}
			</button>
			<button type="button" class="btn btn-admin btn-white" name="ewQuestionAndAnswerDisabled" [(ngModel)]="webcast.questionAndAnswerEnabled" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
				{{ 'UI_Disabled' | translate }}
			</button>
		</div>
	</vb-ui-horizontal-form-group>

	<div *ngIf="features.webcastEngagementSettings.allowQuestionAndAnswer && webcast.questionAndAnswerEnabled" class="form-group row animate-if">
		<label class="control-label col-sm-3"></label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<div [ngClass]="styles.radioGroup" role="radiogroup">
						<input id="ewDisableAnonymousQuestions" type="radio" [value]="WebcastQuestionOptionTypes.IDENTIFIED" [(ngModel)]="webcast.questionOption" name="disableAnonymousQuestions" role="radio"/>

						<label for="ewDisableAnonymousQuestions">{{ 'Event_DisableAnonymousQuestions' | translate }}</label>
					</div>
					<div [ngClass]="styles.radioGroup">
						<input type="radio" id="ewAllowParticipantSelfSelectAnonymousQuestion" [value]="WebcastQuestionOptionTypes.SELFSELECT" [(ngModel)]="webcast.questionOption" name="allowParticipantSelfSelectAnonymousQuestion" role="radio"/>
						<label for="ewAllowParticipantSelfSelectAnonymousQuestion">{{ 'Event_AllowParticipantSelfSelectAnonymousQuestion' | translate }}</label>
					</div>
					<div [ngClass]="styles.radioGroup">
						<input type="radio" id="ewForceAllQuestionsAnonymous" [value]="WebcastQuestionOptionTypes.ANONYMOUS" [(ngModel)]="webcast.questionOption" name="forceAllQuestionsAnonymous" role="radio"/>
						<label for="ewForceAllQuestionsAnonymous">{{ 'Event_ForceAllQuestionsAnonymous' | translate }}</label>
					</div>
				</div>
			</div>
		</div>
	</div>

	<vb-ui-horizontal-form-group>
		<label #uiLabel id="ewEmbeddedContentEnabled">
			{{ 'Event_Embed_Content' | translate }}
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Embed_Content_Tooltip' | translate">
			</vb-ui-tooltip>
		</label>

		<div *ngIf="!accountLevelEmbeddedContentEnabled; else embeddedContentControls" uiControl aria-labelledby="ewEmbeddedContentEnabled">
			<span class="help-block">{{ 'Event_Embed_Content_Disabled' | translate }}</span>
		</div>

		<ng-template #embeddedContentControls>
			<div uiControl aria-labelledby="ewEmbeddedContentEnabled" vbUiRadioBtnGroup>
				<button type="button" class="btn btn-admin btn-white" name="ewEmbeddedContentEnabled" [(ngModel)]="webcast.embeddedContent.isEnabled" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
					{{ 'UI_Enabled' | translate }}
				</button>
				<button type="button" class="btn btn-admin btn-white" name="ewEmbeddedContentEnabled" [(ngModel)]="webcast.embeddedContent.isEnabled" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
					{{ 'UI_Disabled' | translate }}
				</button>
			</div>
		</ng-template>

	</vb-ui-horizontal-form-group>

	<div class="form-group row" *ngIf="accountLevelEmbeddedContentEnabled && webcast.embeddedContent?.isEnabled">
		<label class="control-label col-sm-3">{{ 'Event_Embed_Content_Manage' | translate }}</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<edit-webcast-embedded-content name="ewEmbeddedContentLinks" [isSidebar]="isSidebar" [webcastId]="webcast.id" [(ngModel)]="webcast.embeddedContent.contentLinks">
					</edit-webcast-embedded-content>
				</div>
			</div>
		</div>
	</div>

	<vb-ui-horizontal-form-group *ngIf="features.webcastEngagementSettings.allowSendLinkToAllAttendees">
		<label #uiLabel id="ewBannersEnabled">
			{{ 'Banners' | translate }}
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Banner_Tooltip' | translate">
			</vb-ui-tooltip>
		</label>
		<div uiControl aria-labelledby="ewBannersEnabled" vbUiRadioBtnGroup>
			<button type="button" class="btn btn-admin btn-white" name="ewBannersEnabled" [(ngModel)]="webcast.bannerDetails.isEnabled" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
				{{ 'UI_Enabled' | translate }}
			</button>
			<button type="button" class="btn btn-admin btn-white" name="ewBannersEnabled" [(ngModel)]="webcast.bannerDetails.isEnabled" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
				{{ 'UI_Disabled' | translate }}
			</button>
		</div>
	</vb-ui-horizontal-form-group>

	<div class="form-group row" *ngIf="features.webcastEngagementSettings.allowSendLinkToAllAttendees && webcast.bannerDetails.isEnabled">
		<label class="control-label col-sm-3"></label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<edit-webcast-banner-details name="ewBanners" [isSidebar]="isSidebar" [(ngModel)]="webcast.bannerDetails.banners">
					</edit-webcast-banner-details>
				</div>
			</div>
		</div>
	</div>

	@if(features.webcastEngagementSettings.allowEmojiReactions) {
		<vb-ui-horizontal-form-group>
			<label #uiLabel id="ewReactionEnabled">
				{{ 'Event_Live_Emoji_Reactions' | translate }}
					<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Live_Emoji_Reactions_Tooltip' | translate">
					</vb-ui-tooltip>
			</label>
			<div uiControl aria-labelledby="ewReactionEnabled" vbUiRadioBtnGroup>
				<button type="button" class="btn btn-admin btn-white" name="ewReactionEnabled" [(ngModel)]="webcast.reactionsSettings.enabled" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
					{{ 'UI_Enabled' | translate }}
				</button>
				<button type="button" class="btn btn-admin btn-white" name="ewReactionEnabled" [(ngModel)]="webcast.reactionsSettings.enabled" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
					{{ 'UI_Disabled' | translate }}
				</button>
			</div>
		</vb-ui-horizontal-form-group>

		@if(webcast.reactionsSettings.enabled) {
			<div class="form-group row">
				<div class="col-sm-3"></div>
				<div class="col-sm-9">
					<div class="row">
						<div class="col-sm-6">
							<div class="help-block">{{ 'Event_Live_Emoji_Reactions_Selected_Emojis' | translate : { '0': webcast.reactionsSettings.emojis.length, '1': 5 } }}
								<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Live_Emoji_Reactions_Selected_Emojis_Tooltip' | translate">
								</vb-ui-tooltip>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<emoji-picker #emojiPicker="ngModel" name="reactionEmojis" [(ngModel)]="webcast.reactionsSettings.emojis" [maxLength]="5" required>
							</emoji-picker>
							<div vbUiErrorMessage *ngIf="emojiPicker.invalid">
								{{ 'ThisFieldIsRequired' | translate }}
							</div>
						</div>
					</div>
				</div>
			</div>
		}
	}

	<vb-ui-horizontal-form-group *ngIf="showPresentationFile">
		<label #uiLabel for="ewChoosePresentationFile">{{ 'Event_PresentationFile' | translate }}</label>
		<div uiControl>
			<div class="selected-ppt-file" [hidden]="!webcast.presentationFile">
				<div class="alert alert-info" [ngClass]="[styles.fullWidth, styles.presentationStatus]" [hidden]="!webcast.presentation?.processing">
					<span class="glyphicons refresh rotate-360 margin-right-5"></span>
					{{ 'Event_PresentationFileProcessing' | translate }}
				</div>

				{{webcast.presentationFile?.name}}

				@if(!isSidebar && !webcast.presentation?.processing) {
					<button type="button" class="remove" (click)="removePresentationFile()" [attr.aria-label]="'Remove' | translate">
						<span class="glyphicons remove_2"></span>
					</button>
				}
			</div>

			<div vbUiErrorMessage [hidden]="!webcast.presentation?.processingImagesFailed">
				{{ 'Event_UnableToProcessPresentation' | translate }}
			</div>
			<div vbUiErrorMessage [hidden]="webcast.presentation?.status !== UploadFailed">
				{{ 'Event_PresentationUploadFailed' | translate }}
			</div>

			<div [ngClass]="styles.presentationFileActionWrapper">
				@if (!isSidebar) {
					<div class="btn-file" method="post" enctype="multipart/form-data" fileUpload="presentationFileUpload" [singleFileUploads]="true" (onAdd)="setPresentationFile($event.file)" vbBtnPrimary>
						<span class="vb-icon vb-icon-center vb-icon-file"></span>
						{{ (!webcast.presentationFile ? 'ChooseFile' : 'Event_ReplaceFile') | translate }}
						<input type="file" id="ewChoosePresentationFile" name="presentationFileUpload" [disabled]="webcast.presentation?.processing" [attr.aria-label]="(!webcast.presentationFile ? 'ChooseFile' : 'Event_ReplaceFile') | translate" #presentationFileUpload="ngModel" ngModel>
					</div>
				}

				@if (webcast.presentationFile?.name) {
					<div [ngClass]="styles.checkLabel">
						<input id="ewEnablePresentationFileDownload" type="checkbox" class="checkbox-single" name="presentationFileDownloadAllowed" [(ngModel)]="webcast.presentationFileDownloadAllowed"/>
						<label for="ewEnablePresentationFileDownload">{{ 'Event_PresentationFileDownloadEnabled' | translate }}</label>
					</div>
				}
			</div>
			<span class="help-block padding-bottom-5">{{ 'Event_PresentationFile_Note' | translate }}</span>

			<div vbUiErrorMessage *ngIf="form.control?.get('presentationFileUpload')?.invalid">
				@if (form.control?.get('presentationFileUpload')?.errors?.fileType) {
					{{ 'Event_SelectPresentationFile' | translate }} {{PresentationFileExtensions.join(', ')}}
				}
			</div>
		</div>
	</vb-ui-horizontal-form-group>


	<vb-ui-horizontal-form-group>
		<label #uiLabel id="backgroundImage">
			{{ 'Media_Events_Settings_BkImage' | translate }}
		</label>
		<div uiControl aria-labelledby="backgroundImage">
				<image-selector #imageModel="ngModel" name="backgroundImage" [imageComponentMetadata]="backgroundImageComponentMetadata" [defaultImage]="{ url: '/shared/img/default-thumbnail.png' }" [(ngModel)]="backgroundImageData" (ngModelChange)="onBackgroundSelect()">
				</image-selector>
				<span class="help-block padding-bottom-5">{{ 'Media_Events_Settings_BkImageUploadNote' | translate }}</span>
		</div>
	</vb-ui-horizontal-form-group>
	<!--Background Size-->
	<vb-ui-horizontal-form-group>
		<label #uiLabel id="ewBackgroundSize">{{ 'Event_BackgroundSize' | translate }}</label>
		<div uiControl aria-labelledby="ewBackgroundSize" vbUiRadioBtnGroup>
			<button type="button" class="btn btn-admin btn-white" name="bgFill" [(ngModel)]="webcast.isBackgroundFill" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
				{{ 'Event_BackgroundSize_Fit' | translate }}
			</button>
			<button type="button" class="btn btn-admin btn-white" name="bgFill" [(ngModel)]="webcast.isBackgroundFill" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
				{{ 'Event_BackgroundSize_Fill' | translate }}
			</button>
		</div>
	</vb-ui-horizontal-form-group>
	<vb-ui-horizontal-form-group>
		<label #uiLabel id="previewThumbnailImage">
				{{ 'Media_Events_Settings_PreviewThumbnail' | translate }}
				<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Media_Events_Settings_PreviewThumbnail_Tooltip' | translate">
				</vb-ui-tooltip>
		</label>
		<div uiControl aria-labelledby="previewThumbnailImage">

				<image-selector #imageModel="ngModel" name="previewThumbnailImage" [imageComponentMetadata]="previewThumbnailImageComponentMetadata" [defaultImage]="{ url: '/shared/img/default-thumbnail.png' }" [(ngModel)]="previewThumbnailImageData" (ngModelChange)="onPreviewThumbnailSelect()">
				</image-selector>
				<span class="help-block padding-bottom-5">{{ 'Media_Events_Settings_PreviewThumbnail_Help' | translate }}</span>
		</div>
	</vb-ui-horizontal-form-group>

</div>
